import styled from 'styled-components';

import { grid } from 'quarks/interpolations/grid';

const Grid = styled.div`
  ${grid}
`;

export default Grid;
